import { Injectable } from '@angular/core';
import * as CryptoTS from 'crypto-ts';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  TEMP = {
    KEY: 'FlowFull_auth',
    PASSWORD: '90590348534YYIU!@00asfdadsf@£sxfcdf'
  };
  USER = {
    KEY: 'FlowFull_auth0',
    PASSWORD: '!##0895*()?:}95047834&&tes12323?ADSLklo'
  };
  TOKEN = {
    KEY: 'FlowFull_auth1',
    PASSWORD: '!##0895*()?:}95047834&&tes12323?ADSLklojhkbnsdf678354gjhdfg678'
  };


  constructor(
    private cookie: CookieService
  ) { }

  // DECRYPT THE COOKIES DATA BEFORE SAVE
  private encription(data: any, secret: string) {
    return CryptoTS.AES.encrypt(JSON.stringify(data), secret);
  }
  // DECRYPT THE COOKIES DATA
  private decription(data: any, secret: string) {
    const bytes = CryptoTS.AES.decrypt(data.toString(), secret);
    return JSON.parse(bytes.toString(CryptoTS.enc.Utf8));
  }

  async setUserRole(data: any) {
    return this.cookie.set(this.USER.KEY, this.encription(data, this.USER.PASSWORD).toString(), 7, '/', '', false, 'Strict');
  }

  getUserRole() {
    const DATA = this.cookie.get(this.USER.KEY) !== null ? this.cookie.get(this.USER.KEY) : undefined;
    if (DATA) {
      return this.decription(DATA, this.USER.PASSWORD);
    }
    return null;
  }
  // CLEAR USER ROLE COOKIES
  clearUserRole() {
    this.cookie.delete(this.USER.KEY, '/');
    this.cookie.delete(this.USER.KEY, '/user');
    this.cookie.delete(this.USER.KEY, '/user/*');
  }



  async setUserToken(data: any) {
    return this.cookie.set(this.TOKEN.KEY, this.encription(data, this.TOKEN.PASSWORD).toString(), 7, '/', '', false, 'Strict');
  }

  getUserToken() {
    const DATA = this.cookie.get(this.TOKEN.KEY) !== null ? this.cookie.get(this.TOKEN.KEY) : undefined;
    if (DATA) {
      return this.decription(DATA, this.TOKEN.PASSWORD);
    }
    return null;
  }
  
  // CLEAR USER TOKEN COOKIES
  clearUserToken() {
    this.cookie.delete(this.TOKEN.KEY, '/');
    this.cookie.delete(this.TOKEN.KEY, '/user');
    this.cookie.delete(this.TOKEN.KEY, '/user/*');
  }


  // SAVE TEMP DATA WHEN REQUIRED
  setTempData(data: any) {
    return this.cookie.set(this.TEMP.KEY, this.encription(data, this.TEMP.PASSWORD).toString());
  }
  // GET SAVED TEMP DATA
  getTempData() {
    const DATA = this.cookie.get(this.TEMP.KEY) !== null ? this.cookie.get(this.TEMP.KEY) : undefined;
    if (DATA && DATA !== undefined) {
      return this.decription(DATA, this.TEMP.PASSWORD);
    } else {
      return null;
    }
  }
  // DELETE ANY TEMP DATA IF EXIST
  clearTempData() {
    return this.cookie.delete(this.TEMP.KEY);
  }

}
